import { formatBRL } from './format';

export default function divisionFormatBRL(value) {
  const formatedValue = (value / 100);

  return formatBRL(formatedValue);
}
